import templateUrl from "emun.order/order-details-vendor-invoices.htm";

export default () => ({ templateUrl });
